export default __webpack_public_path__ + "static/404-img-5efa79819beb89daa4ceb22d0e2aadea.png";